export class Vendor {
  id: number;
  contact_id: number;
  address_id: number;
  chart_of_account_id: number;
  is_auto_withdrawal: boolean = false;
  account_number: number;
  description: string;
  created_at: string;
  updated_at: string;
  intranet_id: number;
  is_priority: boolean = false;
  contact_name: string;
  editing: boolean = false;
  matters: Array<any> = [];
}
